<div mdbModal #dropDocumentsModal="mdbModal" class="modal fade left" id="dropDocumentsModal" tabindex="-1">
  <div class="modal-dialog modal-notify modal-info modal-lg" role="document">
    <div class="modal-content">
      <app-spinner [isLoading]="isLoading"></app-spinner>

      <form #dropDocumentsModalForm="ngForm" class="form-horizontal" role="form">
        <div class="modal-header">
          <h4 class="modal-title">{{ 'administration_addDocument_label' | translate }}</h4>
          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" (click)="dropDocumentsModal.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
        </div>
        <div class="modal-body">
          <div class="col-md-12" style="height: 100px;">
            <div class="form-group">
              <div class="">
                <ng-select name="documentTags" [items]="allDocumentTypes" [multiple]="true"
                  placeholder="{{'administration_selectOneorMore_documentTags_label' | translate}}" bindLabel="name"
                  bindValue="id" [(ngModel)]="selectedDocumentTags" (remove)="removeTag($event)" (add)="addTag($event)">
                </ng-select>
              </div>
            </div>
          </div>
          <ul style="display:block;min-width:100%;margin-left:15px;">
            <li style="position:relative;width:30%;display:inline-block;vertical-align:top"
              *ngFor="let type of selectedDocumentList;let i =index">
              <span class="fa fa-times-circle removeType" (click)="removeSelectedType(type, i);" title="Remove"></span>
              <label class="upload-button" style="display: block !important">
                <div class="dropbox" appDragDrop (onFileDropped)="uploadFile($event, type)">
                  {{type.name}}
                  <input type="file" hidden multiple #uploader name="{{type.id}}" #fileInput
                    (change)="uploadFile($event.target.files, type, $event)">
                </div>
              </label>
              <div class="drop-list">
                <ul style="padding:0;">
                  <li *ngFor="let doc of type.files;let i =index">
                    <span (click)="removeFile(doc.id)" class="fa fa-trash text-ghosted cursorme pull-right"
                      style="padding-top:5px"></span>
                    <div style="width:200px;white-space:nowrap;overflow:hidden;text-overflow: ellipsis;">{{doc.name}}
                    </div>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div class="modal-footer">
          <button mdbBtn type="button" size="sm" class="waves-light primary-color-dark text-white" mdbWavesEffect
          [disabled]="checkSelectedDocsValidation()" (click)="startUpload()">{{'BTN_save_label' | translate}}</button>
          <button mdbBtn type="button" size="sm" class="waves-light unique-color-dark text-white" mdbWavesEffect
            (click)="dropDocumentsModal.hide()">{{'BTN_cancel_label' | translate}}</button>
        </div>
      </form>
    </div>
  </div>
</div>